import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { TabsSherwood } from '../../components/Tabs';
import AgendaConfigurationMock from './Agenda';
import AestheticsConfigurationMock from './Aesthetics';
import BillingConfigurationMock from './Billing';

const DemoConfiguration: React.FC = () => {
  const [tabSelected, setTabSelected] = useState(0);
  const investigation = useSelector((state: any) => state.investigations.currentInvestigation);

  if (!investigation?.demo) {
    return <Box p={3}><Translate id="hospital.demo_configuration.access_denied" /></Box>;
  }

  const labels = ['Agenda', 'Aesthetics', 'Billing'];
  const children = [
    <AgendaConfigurationMock key="agenda" />,
    <AestheticsConfigurationMock key="aesthetics" />,
    <BillingConfigurationMock key="billing" />,
  ];

  return (
    <TabsSherwood
      name="Demo Configuration"
      style={{ color: 'white' }}
      whiteBackground={false}
      tabChangeCallback={(idx) => setTabSelected(idx)}
      initTab={tabSelected}
      labels={labels}
    >
      {children}
    </TabsSherwood>
  );
};

export default DemoConfiguration;
